module.exports = __webpack_public_path__ + "img/behold-7.54df815d.png";